webpackJsonp([3],{

/***/ 108:
/***/ (function(module, exports, __webpack_require__) {

// process.env.NODE_ENV === 'production' ? console.log('Production mode!') : require('__page/index.html');
var mc = __webpack_require__(0);
mc.runVue(['Slider', 'Navigation', 'selectList']);
mc.runComponents(['rating']);
mc.runFooter();

/***/ })

},[108]);


// WEBPACK FOOTER //
// bundles/stock.bundle.js